import Styles from "../styles/Styles";

import { CustomText } from "../../../components";
import colors from "../../../config/colors";
import { fonts, pagesConfig, Spacing } from "../../../config";
import { useLocation, useNavigate } from "react-router-dom";
import RoleSelect from "../../../components/others/SelectHeader";
import { SessionStorage } from "../../../utils";
import { useContext, useEffect, useState } from "react";
import { StorageContext } from "../../../contexts/StorageContext";
import { get } from "http";

type CustomHeaderProps = {
  openMenu: () => void;
  user: any;
};

function Header({ openMenu, user }: CustomHeaderProps) {
  const { getData, addData } = useContext<any>(StorageContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [condominiumListState, setCondominiumListState] = useState<any[]>([]);
  const [currentCondominium, setCurrentCondominium] = useState<any>(null);

  const classes = Styles.useStyles();
  const getCurrentPage = (path) => {
    let currentPage = <></>;

    pagesConfig.logged.map((item) => {
      return item.pages.map((element: any) => {
        if (path === element?.path) {
          currentPage = (
            <div>
              <CustomText
                fontSize={18 / 8}
                fontFamily={fonts.bold}
                textColor={colors.blue}
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  paddingRight: "8px",
                }}
              >
                {element?.icon && (
                  <element.icon alt="" className={classes.icon} />
                )}
                {element?.title}
              </CustomText>
              <Styles.TextDescript>{element?.description}</Styles.TextDescript>
            </div>
          );
        }
        return element;
      });
    });
    return currentPage;
  };

  useEffect(() => {
    if (condominiumListState?.length > 0 ) return;
    const condominiumList = getData("condominiumList");
    const currentCompany = getData("company_type");
    setCondominiumListState(condominiumList);
  }, [getData]);

  const roleUser = () => {
    if (user?.role === "maintainer") {
      return "Manutenção";
    } else if (user?.role === "superadmin") {
    return "Admin Interno";
    } else if (user?.role === "owner") {
      return "Super Admin";
    } else if (user?.role === "admin") {
      return "Admin";
    } else if (user?.role === "manager") {
      return "Gestor";
    } else if (user?.role === "tenant") {
      return "Inquilino";
    }
  };

  return (
    <Styles.Container id="header-menu">
      <Styles.FirstContentGroup>
        <Styles.Rectangle onClick={openMenu}>
          <Styles.IconMenu />
        </Styles.Rectangle>
        {getCurrentPage(location.pathname)}
      </Styles.FirstContentGroup>

      <Styles.UserContentGroup>
        <CustomText
          textColor={colors.blue}
          fontFamily={fonts.semibold}
          fontSize={2}
        >
          {user?.name}
        </CustomText>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            flex: "row",
            gap: Spacing(2),
            alignItems: "center",
            paddingTop: Spacing(0.5),
            marginRight: Spacing(4),
          }}
        >
          <CustomText
            textColor={colors.black}
            fontFamily={fonts.regular}
            style={{ height: "fit-content" }}
            fontSize={1.75}
          >
            {roleUser()}
          </CustomText>
          <CustomText
            textColor={"#00000054"}
            fontFamily={fonts.regular}
            fontSize={2.5}
            style={{ height: "fit-content", lineHeight: "100%" }}
          >
            •
          </CustomText>
          {condominiumListState?.length > 0 && <RoleSelect
            defaultValue={getData("company_type") || "error"}
            style={{ wordBreak: "break-word"}}
            onChange={(value) => {
              addData("company_type", value.value);
              navigate("/refresh", { replace: true });
              setTimeout(() => {
                navigate(location.pathname, { replace: true });
              }, 0);
            }}
            options={condominiumListState.map((item) => ({
              label: item.name,
              value: item.id,
            }))}
          />}
        </div>
      </Styles.UserContentGroup>
    </Styles.Container>
  );
}

export default Header;
